export const CUSTOM_FAQ_URL = 'custom_faq_url'
export const USER_WEB_STORAGE_VIEW_TAB = 'user_web.storage.view_tab'
export const USER_WEB_SHOW_REFERRALS = 'user_web.show_referrals'
export const HIDE_ADD_PLAN = 'hide_add_plan'
export const HIDE_CHANGE_PLAN = 'hide_change_plan'
export const HIDE_DEDUCTIBLE_CREDIT_AREA = 'hide_deductible_credit_area'
export const CUSTOM_CLAIMS_URL = 'custom_claims_url'



// WEBPACK FOOTER //
// ./src/constants/ui-settings/uiSettings.js